import api from 'api'
import { downloadBlob, filenameFromContentDisposition } from 'lib/downloadBlob'

export async function downloadInvoiceCsv(invoiceId: number) {
  const response = await api.get<Blob>(
    `/admin/charges/invoices/${invoiceId}/csv`,
    { responseType: 'blob' }
  )

  const filename = filenameFromContentDisposition(
    response.headers['content-disposition'],
    `invoice_${invoiceId}.csv`
  )
  downloadBlob(new Blob([response.data]), filename)
}
